import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/shared-hosting")({
  beforeLoad: () => {
    throw redirect({ to: "/products/web-hosting/shared-hosting" });
  },
});
